<template>
  <div class="form">
    <h1 class="form__title">{{ t('auth.reset.title') }}</h1>
    <p class="form__text">{{ t('auth.reset.text') }}</p>
    <form @submit.prevent="reset" class="form__form">
      <ui-input
          :type="'email'"
          :placeholder="t('fields.email')"
          :rules="[isEmail]"
          v-model="email"
      />
      <ui-button
          :type="'submit'"
          class="form__button"
          :isDisabled="!isFormValid"
          :isLoading="isLoading"
      >
        {{ t('buttons.reset') }}
      </ui-button>
    </form>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import {isEmail} from "@/core/rules/textFieldRules.js";
import UiInput from "@/components/ui/ui-input.vue";
import {computed, ref} from "vue";
import UiButton from "@/components/ui/ui-button.vue";
import {ElNotification} from "element-plus";
import {Auth} from "@/core/api/auth.js";

const {t} = useI18n()

const email = ref('')

const isLoading = ref(false)

const isFormValid = computed(() => {
  return (
      isEmail(email.value) === true
  )
})

const reset = async () => {
  const res = await Auth.resetPassword(email.value);

  ElNotification({
    message: t('popup.reset')
  })
}
</script>

<style lang="scss" scoped>
.form {
  &__title {
    color: #F3F3F3;
    text-align: center;
    font-size: 64px;
    font-weight: 700;
  }

  &__text {
    margin-top: 15px;
    color: $white;
    text-align: center;
    font-size: 20px;

    & a {
      transition: 0.2s;
      font-weight: 700;

      @include hover {
        color: #b7b7b7;
      }
    }
  }

  &__form {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }

  &__box {
    display: flex;
    align-items: flex-start;
    gap: 15px;
  }

  &__checkboxes {
    margin-top: 10px;
    display: flex;
    align-items: center;
    gap: 35px;
  }

  &__link {
    text-decoration: underline;
  }

  &__button {
    margin-top: 10px;
    width: fit-content !important;
    padding: 8px 40px;
  }
}
</style>